const GAP = 8
const GUTTER = 16

type Anchored = { left: number; width: number; top?: number; bottom?: number }

/** Fixed-position style for a panel hanging off a trigger, flipped above it when it would
 * otherwise run off the bottom of the viewport. */
export function anchoredStyle(
  anchor: DOMRect,
  { width, height, align = 'start', gap = GAP }: { width: number; height: number; align?: 'start' | 'end'; gap?: number },
): Anchored {
  const preferred = align === 'end' ? anchor.right - width : anchor.left
  const left = Math.max(GUTTER, Math.min(preferred, window.innerWidth - width - GUTTER))
  const below = window.innerHeight - anchor.bottom

  return below < height + gap + GUTTER && anchor.top > below
    ? { left, width, bottom: window.innerHeight - anchor.top + gap }
    : { left, width, top: anchor.bottom + gap }
}
